import React, { Fragment } from 'react';

import { ListHelmet } from 'components';
import {
    AsyncMobileFilters,
    AsyncMobileFiltersCtxComponent,
    AsyncSportsNavigation,
} from 'modules/filters/async';
import { AsyncFreebetSelect } from 'modules/freebet/async';
import useMatchListNavigation from './useMatchListNavigation';

import './matchListNavigation.scss';

const MatchListNavigation: React.FC = ({ children }) => {
    const {
        isBettingPage,
        isCompact,
        withSportNavigation,
        withRender,
        withFilters,
    } = useMatchListNavigation();

    if (!withRender) return <Fragment>{children}</Fragment>;

    return (
        <AsyncMobileFiltersCtxComponent>
            {isBettingPage && isCompact && (
                <Fragment>
                    <div styleName="wrapper-top-menu">
                        <AsyncFreebetSelect />
                    </div>

                    {withFilters && <AsyncMobileFilters />}
                </Fragment>
            )}

            {isBettingPage && window.__app.previousLocation && <ListHelmet />}
            {!isCompact && withSportNavigation && <AsyncSportsNavigation />}
            {children}
        </AsyncMobileFiltersCtxComponent>
    );
};

export default MatchListNavigation;
